<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('podcast-episode', true)">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit Podcast</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <div class="mb-4">
          <p class="input-title text-black">Title</p>
          <base-input
            alternative
            class="mb-3"
            name="Title"
            placeholder="Title"
            :rules="{ required: true }"
            v-model="episode_data.title"
            maxlength="200"
          >
          </base-input>
        </div>

        <div class="mb-4">
          <p class="input-title text-black">Podcast URL</p>
          <base-input
            alternative
            class="mb-3"
            name="Podcast URL"
            :rules="{ required: true }"
            placeholder="Podcast URL"
            v-model="episode_data.link"
          >
          </base-input>
        </div>
        <div
          class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
        >
          Recommended Size: 700 × 500px
        </div>
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />

        <div v-if="image">
          <p class="mb-2 text-danger">Image Preview</p>

          <div class="flex cursor-pointer items-center my-2" v-if="image">
            <base-button type="danger" class="px-8" @click="handleRemove">
              Remove image
            </base-button>
          </div>
          <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>
          <img v-if="image" :src="image" ref="cover" />
        </div>

        <div class="mt-3 mb-4">
          <p class="mb-2">Uploaded Image</p>
          <img
            class="w-1/2"
            alt="uploaded-image"
            :src="$imageURL + '/' + episode_data.image"
          />
        </div>

        <!-- <div>
          <p class="input-title text-black">Description</p>
          <base-input
            alternative
            class="mb-3"
            name="Description"
            :rules="{ required: true }"
            placeholder="Description"
            maxlength="800"
            v-model="episode_data.description"
          >
          </base-input>
        </div> -->

        <b-form-group label="Description">
          <quill-editor
            v-model="episode_data.description"
            :options="editorOption"
            class="quil-h200px my-2"
          />
        </b-form-group>

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Save</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      image: "",
      coverImage: "",
      episodes: [],
      title: "",
      category: "",
      editorOption: {
        theme: "snow",
      },

      imageErr: false,
      msg: {},
      pageData: {},
      episode_data: {},
    };
  },
  computed: {
    ...mapState("podcast", {
      selectedEpisode: "selectedEpisode",
    }),
  },
  watch: {
    pageData(val) {
      this.episode_data = { ...val };
    },
  },
  methods: {
    handleSuccess(image) {
      this.imageErr = false;

      if (!image.type.startsWith("image/")) {
        this.$swal.fire({
          title: "Invalid File",
          text: "Please upload an image file only!",
          // html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          icon: "error",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }

      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          text: "Please ensure that the file size does not exceed 5MB",
          icon: "warning",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }

      this.coverImage = image;
      this.readerData(image);
    },

    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      // let payload = {
      //   episodeId: this.episode_data._id,
      //   title: this.episode_data.title,
      //   link: this.episode_data.link,
      //   description: this.episode_data.description,
      // };

      let FormData = require("form-data");
      let data = new FormData();
      data.append("episodeId", this.episode_data._id);
      data.append("title", this.episode_data.title);
      data.append("link", this.episode_data.link);
      data.append("image", this.coverImage);
      if (this.episode_data.description)
        data.append("description", this.episode_data.description);
      if (!this.episode_data.description) {
        this.$notify.error({
          message: "Description is required",
          position: "top-right",
        });
        return;
      }
      let loader = this.$loading();
      try {
        const editData = await this.$store.dispatch(
          "podcast/update_episode",
          data
        );
        // if (editData.code == 200) {
        this.handleClick("podcast-episode", true);
        this.$swal.fire({
          text: "Your podcast has been successfully edited!",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        // }
      } catch (error) {
        console.log(error);
        if (error) {
          loader.close();
        }
      }
    },
    async init() {
      this.pageData = this.selectedEpisode;
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name, query = false) {
      if (query) {
        this.$router.push({
          name: name,
          query: {
            pid: this.$route.query.pid,
            cid: this.$route.query.cid,
          },
        });
      } else {
        this.$router.push({ name: name });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.h300px {
  height: 300px !important;
}
.imgupload {
  height: 270px !important;
}
</style>
